<template>
  <!-- 发票明细 -->
  <div class="page-container" id="invoiceDetailContainer">
    <el-form :model="invoiceDetailForm"
             ref="ruleFormRef"
             class="form-panel"
             label-position="left">
      <el-row class="content-panel">
        <el-row>
          <el-col>
            <el-button type="primary" size="small" plain @click="downloadAttachment()">Download</el-button>
          </el-col>
        </el-row>
        <el-row :gutter="22">
          <el-col :span="5">
            <el-form-item label="ATTN:">
              <el-input size="mini" v-model="invoiceDetailForm.settleCustName" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="Note No:">
              <el-input size="mini" v-model="invoiceDetailForm.invoiceNo" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="Type:">
              <el-select clearable v-model="invoiceDetailForm.invoiceType" placeholder="Please select the invoice type" disabled>
                <el-option
                  v-for="item in invoiceTypeList"
                  :key="item.key"
                  :label="item.value"
                  :value="item.key"
                  disabled="true"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="ISSUED BY:">
              <el-input size="mini" v-model="invoiceDetailForm.issuedBy" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="INV DATE:">
              <el-date-picker
                v-model="invoiceDetailForm.issuedDate"
                align="right"
                type="date"
                style="width: 100%"
                size="mini"
                placeholder=""
                disabled
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
      </el-row>

      <el-row class="panel-top" type="flex" justify="space-between" align="top">
        <el-col :span="14" class="border-rang" style="width:63%">
          <el-row type="flex" justify="start" align="top" :gutter="10" style="margin:8px 6px">
            <hot-table
              ref="invoiceContentTableRef"
              :data-source="bcPublicOrder"
              :settings="invoiceContentTableSettings"
              col-settings-key="invoiceContentKey"
              @cellDblclick="invoiceContentTableCellClick"
              :rules="invoiceContentTableRules"
              drag-check="false"
            >
              <hot-column :has-tip="true" data="mblNo" title="BO/L#:"></hot-column>
              <hot-column :has-tip="true" data="vesselName" title="VSL/VOY"></hot-column>
              <hot-column :has-tip="true" data="etd" date-format="YYYY-MM-DD" title="ETD"></hot-column>
              <hot-column :has-tip="true" data="polName" title="P.LOAD"></hot-column>
              <hot-column :has-tip="true" data="podName" title="P.DISCHAR"></hot-column>
              <hot-column :has-tip="true" data="" title="P.DELIVERY"></hot-column>
              <hot-column :has-tip="true" data="" title="(SH)"></hot-column>
              <hot-column :has-tip="true" data="" title="(CO)"></hot-column>
              <hot-column :has-tip="true" data="" title="(NF)"></hot-column>
              <hot-column :has-tip="true" data="" title="COMMODITY:"></hot-column>
            </hot-table>
          </el-row>
        </el-col>
        <el-col :span="12" style="width:36%" class="border-rang">
          <el-col :span="24">
            <el-row type="flex" justify="start" align="top" :gutter="10" style="margin:8px 6px">
              <hot-table
                ref="invoiceContentTableRef"
                :data-source="bcFreights"
                :settings="expenseInformationTableSettings"
                col-settings-key="invoiceContentKey"
              >
                <hot-column :has-tip="true" data="freightType" title="Description"></hot-column>
                <hot-column :has-tip="true" data="settleCurrencyCode" title="Currency"></hot-column>
                <hot-column :has-tip="true" data="unitPrice" title="PRICE"></hot-column>
              </hot-table>
            </el-row>
            <el-row type="flex" justify="start" align="top" :gutter="10">
              <el-col :span="9">
                <el-form-item label="">
                  <el-col :span="17" style="float:right">
                    <input hidden>
                  </el-col>
                </el-form-item>
              </el-col>
              <el-col :span="14">
                <el-form-item label="TTL: USD: ">
                  <el-col :span="17" style="float:right">
                    <el-input size="mini" ></el-input>
                  </el-col>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
        </el-col>
      </el-row>

      <el-row class="panel-top" type="flex" justify="space-between" align="top">
        <el-col :span="12" class="border-rang" style="border-right: 0px">
          <el-col :span="24">
            <el-row type="flex" justify="start" align="top" :gutter="10" style="margin: auto">
              <el-col :span="23">
                <el-form-item label="Beneficiary:">
                  <el-input size="mini" v-model="invoiceDetailForm.settleOfficeName"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row type="flex" justify="start" align="top" :gutter="10" style="margin: auto">
              <el-col :span="23">
                <el-form-item label="Beneficiary Bank:">
                  <el-input size="mini"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row type="flex" justify="start" align="top" :gutter="10" style="margin: auto">
              <el-col :span="23">
                <el-form-item label="Bank Address:">
                  <el-input size="mini" ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row type="flex" justify="start" align="top" :gutter="10" style="margin: auto">
              <el-col :span="23">
                <el-form-item label="Swift Code:">
                  <el-input size="mini" ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
        </el-col>
        <el-col :span="12" class="border-rang" style="border-left: 0px">
          <el-col :span="24">
            <el-row type="flex" justify="start" align="top" :gutter="10" style="margin: auto">
              <el-col :span="23">
                <el-form-item label="Beneficiary Bank Account:">
                  <el-input size="mini" ></el-input>
                  <el-input size="mini" ></el-input>
                  <el-input size="mini" ></el-input>
                  <el-input size="mini" ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
        </el-col>
      </el-row>

    </el-form>
  </div>
</template>

<script>

import { queryDictRows } from "@/api/commonService";
import { queryInvoice,downloadInvoice } from "@/api/queryMainSystem";

export default {
  data() {
    return {
      invoiceUrl: '',
      invoiceTypeList: [], //发票类型
      invoiceDetailForm: {},
      // 发票内容
      invoiceContentTableDataSource: [],
      bcPublicOrder: [],
      bcFreights: [],
      invoiceContentTableSettings: {
        height: 200,
        autoColumnSize: true,
        stretchH: 'none', // 根据宽度横向扩展，last:只扩展最后一列，none：默认不扩展
        ...this.$systemConfig.tableConfig,
      },
      expenseInformationTableSettings: {
        height: 270,
        autoColumnSize: true,
        stretchH: 'none', // 根据宽度横向扩展，last:只扩展最后一列，none：默认不扩展
        ...this.$systemConfig.tableConfig,
        showSelection: false,
      },
      invoiceContentTableRules: {},
      searchData: {
        invoiceSettlementCustomer: null,
        invoiceNumber: null,
        invoiceType: null,
        issuedBy: null,
        issuedDate: null,
      },
      //
      bcPublic_columns_nameVoyage: [
        {
          title: "VSL/VOY",
          field: "bcPublicNameVoyage",
        },
      ],
    };
  },
  async created() {

    this.examId = this.$route.params.key;
  },
  mounted() {
    let self = this
    console.log(self.$route.params.ebInvoiceId)
    if(self.$route.params && self.$route.params.ebInvoiceId) {
      self.queryInvoiceDetail(self.$route.params.ebInvoiceId)
    }
    // 监听外层容器div宽度的变化，做表格自适应
    self.resizeObserver = new ResizeObserver(entries => {
      self.$nextTick(() => {
        self.$refs.invoiceContentTableRef.resizeTo(entries[0].target.clientWidth - 32)
      })
    })
    self.resizeObserver.observe(document.getElementById("invoiceDetailContainer"))
  },
  methods: {
    //联想控件
    bcPublic_queryMethod_nameVoyage(){

    },
    //修改日期
    changeissuedDateTo() {
      let self = this;
      self.searchData.issuedDateTo = new Date(self.searchData.issuedDateTo.getTime() + 1000 * 24 * 3600 - 100)
    },
    //行单击事件
    invoiceContentTableRowClick() {

    },
    //双击事件
    invoiceContentTableCellClick() {

    },
    //下载附件
    downloadAttachment() {
      let self = this;
      downloadInvoice(self.invoiceUrl).then(res => {
        if(res.success) {
          self.$coreMethods.message("info", "开始下载");
        }else{
          self.$coreMethods.message("error", "下载失败");
        }
      });
    },
    //类型联想控件
    queryDictRows() {
      let self = this;
      queryDictRows("MD_CODE_DICT$MD_INVOICE_TYPE").then((res) => {
        self.invoiceTypeList = res.MD_CODE_DICT$MD_INVOICE_TYPE;
        let dict = [];
        res.MD_CODE_DICT$MD_INVOICE_TYPE.forEach((item) => {
          let param = {};
          param.name = item.value;
          param.value = item.key;
          dict.push(param);
        });
        console.log(dict)
        self.$hotTableUtils.registDict({
          'MD_INVOICE_TYPE': dict,
        });
      });
    },
    queryInvoiceDetail(id) {
      let self = this;
      let data = {
        bcInvoiceId: id,
        isDetail: 'Y'
      }
      queryInvoice(data).then(res => {
        if(res.success) {
          res.records.records[0].telAndAdress = res.records.records[0].tel + '/' + res.records.records[0].addressCn
          res.records.records[0].bankNameAndAccount = res.records.records[0].bankName + '/' + res.records.records[0].bankAccount
          self.invoiceDetailForm = res.records.records[0]
          self.invoiceUrl = res.records.records[0].invoiceUrl
          self.invoiceContentTableDataSource = res.records.records[0].bcInvoiceContents
          self.bcPublicOrder = res.records.records[0].bcPublicOrder
          self.bcFreights = res.records.records[0].bcPublicOrder.bcFreights
          console.log(res)
        } else {
          self.$coreMethods.message("error", "查询失败");
        }
      })
    },
  }
};
</script>

<style scoped lang="scss">
::v-deep .el-form-item__label {
  line-height: 36px !important;
}
</style>
